import { createObservableDataAction, IAction, IActionContext, IActionInput, CacheType, ICreateActionContext } from '@msdyn365-commerce/core';

export interface AccordionStates {
    [key: string]: {
        isAllExpanded?: boolean;
        children?: {
            [key: string]: boolean;
        }
    };
}

//==========================================================
// AccordionState Input Action
//==========================================================
export class AccordionStateInput implements IActionInput {
    public result: AccordionStates;

    //------------------------------------------------------
    // Constructor
    //------------------------------------------------------
    constructor(result: AccordionStates) {
        this.result = result;
    }

    //------------------------------------------------------
    // Caching
    //------------------------------------------------------
    public getCacheKey = () => 'Accordion';
    public getCacheObjectType = () => 'AccordionState';
    public dataCacheType = (): CacheType => 'none';
}
//==========================================================

export function createAccordionStateInput(result: AccordionStates): AccordionStateInput {
    return new AccordionStateInput(result);
}

const createAccordionStateInputInternal = (): AccordionStateInput => {
    return createAccordionStateInput({});
};

async function getAccordionStateAction(input: AccordionStateInput, ctx: IActionContext): Promise<AccordionStates> {
    return input.result;
}

export const getAccordionStateDataAction = createObservableDataAction<AccordionStates>({
    id: 'get-accordion-state',
    action: <IAction<AccordionStates>>getAccordionStateAction,
    input: <(args: ICreateActionContext) => AccordionStateInput>createAccordionStateInputInternal
});

export default getAccordionStateDataAction;
